import { cva } from '@/styled-system/css';

export const expandIconRecipe = cva({
  base: {
    display: 'inline-flex',
    transformOrigin: 'center',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'transform',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: 'cubic-bezier(0.76, 0, 0.24, 1)',
  },
  variants: {
    open: {
      true: {
        transform: 'rotate(180deg)',
      },
      false: {
        transform: 'rotate(0deg)',
      },
    },
  },
});
